import { useState, useEffect } from "react";
import { API_BASE } from "@config/env";
import axios from "axios";
import SectionCard from "./SectionCard";

const post = (ep, f) => {
  const fd = new FormData();
  Object.entries(f).forEach(([k,v]) => fd.append(k,v));
  return axios.post(`${API_BASE}${ep}`, fd).then(r=>r.data).catch(()=>null);
};

export default function RecruiterNotesTab({ resourceSlug, userSlug }) {
  const [notes,   setNotes]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [text,    setText]    = useState("");
  const [saving,  setSaving]  = useState(false);

  const load = () => {
    post("get-resource-details", { resource_slug: resourceSlug, user_slug: userSlug })
      .then(d => {
        const n = d?.resource_details?.recruiter_notes;
        setNotes(Array.isArray(n) ? n : []);
        setLoading(false);
      });
  };

  useEffect(() => { load(); }, [resourceSlug]);

  const addNote = async () => {
    if (!text.trim()) return;
    setSaving(true);
    await post("create-recruiter-note", { user_slug: userSlug, resource_slug: resourceSlug, note: text });
    setText(""); setSaving(false); load();
  };

  return (
    <SectionCard title="Recruiter Notes">
      <div style={{ marginBottom:14 }}>
        <textarea value={text} onChange={e=>setText(e.target.value)} rows={3}
          placeholder="Add a note about this candidate..."
          style={{ width:"100%", boxSizing:"border-box", padding:"9px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", resize:"vertical", background:"var(--fc-card-bg)", color:"var(--fc-text-primary)" }}
          onFocus={e=>e.target.style.borderColor="#2563EB"} onBlur={e=>e.target.style.borderColor="var(--fc-border)"} />
        <button onClick={addNote} disabled={saving||!text.trim()} className="fc-btn fc-btn-sm fc-btn-primary fc-btn-pill" style={{marginTop:8}}>
          {saving ? <><i className="fa-solid fa-spinner fa-spin me-1" style={{fontSize:10}}/>Saving...</> : "Add Note"}
        </button>
      </div>
      {loading
        ? <div style={{textAlign:"center",color:"var(--fc-text-subtle)",padding:"16px 0"}}><i className="fa-solid fa-spinner fa-spin"/></div>
        : notes.length === 0
          ? <div style={{color:"var(--fc-text-subtle)",fontSize:13,textAlign:"center",padding:"16px 0"}}>No notes yet. Add your first note above.</div>
          : notes.map((n,i) => (
              <div key={n.note_id||i} style={{ padding:"12px 14px", background:"var(--fc-bg-light)", borderRadius:10, marginBottom:8, borderLeft:"3px solid #2563EB" }}>
                <p style={{ fontSize:13, color:"var(--fc-text-secondary)", lineHeight:1.6, margin:0 }}>{n.note}</p>
                {n.added_on && <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:6 }}>{n.added_on}</div>}
              </div>
            ))
      }
    </SectionCard>
  );
}
